import List from 'src/storage/list';
import { popupModel } from 'src/components/complex';
import { getRouter } from 'src/helpers';

class ClinicManagersModel extends List {
  id = 'ClinicManagersModel';
  defaultState = () => ({
    current: 'recent',
    total: 0,
    pageIndex: 0,
    tab: 'managers',
    sortBy: {
      sortKey: 'managerAddedDate',
      desc: true
    },
    updating: {}
  });

  refreshOnInit = true;
  refreshOnSubscribe = false;
  sortBy = null;

  apiConfig = {
    refresh: {
      url: 'clinic/manager/list',
      validation: {
        skip: 'skip',
        limit: 'limit'
      },
      cancellable: true,
      event: 'ClinicManagersModel_refresh'
    },
    list: {
      url: 'clinic/manager/list',
      validation: {
        skip: 'skip',
        limit: 'limit'
      },
      cancellable: true
    },
    search: {
      url: 'clinic/manager/list',
      validation: {
        skip: 'skip',
        limit: 'limit'
      },
      cancellable: true
    },
    remove: {
      url: 'clinic/manager/remove',
      validation: {},
      cancellable: true
    },
    update: {
      url: 'clinic/manager/update',
      validation: {
        id: 'baseId'
      },
      cancellable: true
    },
    login: {
      url: 'clinic/manager/login',
      validation: {
        id: 'baseId'
      },
      cancellable: true
    },
    hospitals: {
      url: 'hospital/list',
      validation: {},
      cancellable: true
    }
  };

  _events = {
    'ws:modify_manager': 'onManager',
    ClinicManagersModel_refresh: 'loadTotalHospital',
    profile: 'handleChangeProfileAndSwitchAccount'
  };

  onManager = (data) => {
    if (data.managerRemovedDate) this.removeItem(data.id);
    else {
      this._mergeItems([data], null, true);

      this.trigger();
    }
  };
  _matchMergeItem = (n, o) => {
    return {
      ...o,
      ...n
    };
  };

  listParams() {
    let req = {
      skip: this.state.pageIndex * this.listLimit,
      limit: this.listLimit,
      sortBy: this.state.sortBy
    };
    let query = this.listInput('search');
    if (query.length > 0) {
      req.query = query;
    }
    return req;
  }

  remove = (item, cb) => {
    let req = {
      id: item.id
    };
    this.api('remove', req, (err, data, success) => {
      cb && cb(err, data, success);
      !err && this.removeItem(item.id);
    });
  };

  logAsManager = (item) => {
    popupModel.setActivePopup('loading', {
      active: true
    });
    if (this.getApiState('login').loading) return this.log('logAsManager: processing');
    const url = getRouter()?.location.pathname;
    this.api('login', { id: item.id, url }, (err, res, success) => {
      if (success) {
        this.emit('auth', res.session);
        this.foxsocket().disconnect();
        this.foxsocket().ensureConnect(true);
        this.emit('accountSwitched', res.session);
      }

      popupModel.setActivePopup('loading', { active: false });
    });
  };
  active = (item) => {
    this.setState({ updating: { [item.id]: { managerActive: !item.managerActive } } });
    this.updateSwitch(item, {
      id: item.id,
      managerActive: !item.managerActive
    });
  };
  admin = (item) => {
    this.setState({ updating: { [item.id]: { managerAdmin: !item.managerAdmin } } });
    this.updateSwitch(item, {
      id: item.id,
      managerAdmin: !item.managerAdmin
    });
  };

  loadTotalHospital = () => {
    this.api(
      'hospitals',
      {
        limit: 1,
        skip: 0
      },
      (err, data) => {
        !err && this.setState({ hospitalTotal: data.total });
      }
    );
  };

  accessAll = (item, key, value) => {
    this.setState({ updating: { [item.id]: { [key]: value } } });
    this.updateSwitch(item, {
      id: item.id,
      managerAccessAll: { [key]: value }
    });
  };

  updateSwitch = (item, req) => {
    this.api('update', req, (err, data) => {
      this.setStateSilent({ updating: {} });
      !err && this.updateItem({ ...item, ...data });
    });
  };

  checkWithUpdating = (item, key, def) => {
    return this.state.updating[item.id] && this.state.updating[item.id][key] !== undefined
      ? this.state.updating[item.id][key]
      : def;
  };
}

const model = new ClinicManagersModel();
export default model;
